module.exports = __webpack_public_path__ + "public/img/7.0d986af5.png";